import { render, staticRenderFns } from "./TwoBottomBtn.vue?vue&type=template&id=4e5b3829&scoped=true&"
import script from "./TwoBottomBtn.vue?vue&type=script&lang=js&"
export * from "./TwoBottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./TwoBottomBtn.vue?vue&type=style&index=0&id=4e5b3829&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b3829",
  null
  
)

export default component.exports